import { render, staticRenderFns } from "./Stage2.vue?vue&type=template&id=044db186&scoped=true&"
import script from "./Stage2.vue?vue&type=script&lang=js&"
export * from "./Stage2.vue?vue&type=script&lang=js&"
import style0 from "./Stage2.vue?vue&type=style&index=0&id=044db186&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044db186",
  null
  
)

export default component.exports